<template>
  <DragDialog
    title="外部贴图"
    :width="1000"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div class="operation-area-box">
      <div class="common-button-box">
        <el-button
          key="uploadBtn"
          type="primary"
          size="small"
          class="upload-btn primary-btn"
          id="rvt-uvmap-upload"
          @click="uploadFile">
          上传
        </el-button>
        <el-button
          size="small"
          class="normal-btn"
          @click="bathchDownload"
          >批量下载</el-button
        >
        <el-button
          size="small"
          class="normal-btn"
          @click="batchDelete"
          >批量删除</el-button
        >
      </div>
      <div class="filter-box">
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            v-model="keywords"
            placeholder="请输入文件名称"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search icon"
              @click="search" />
          </el-input>
        </div>
        <div
          class="icon-box operation-icon"
          @click="switchViewMode">
          <icon-svg
            size="24"
            v-if="currViewMode === 'table'"
            icon-class="icon-suolvetushitu" />
          <icon-svg
            size="24"
            v-else
            icon-class="icon-liebiaoshitu1" />
        </div>
      </div>
    </div>
    <div class="uvmap-data-box">
      <div class="tip-box public-tips-primary">
        注：修改后的贴图，需再次提交转换，才可以看到最新贴图
      </div>
      <div
        class="common-table-box"
        v-if="currViewMode === 'table'">
        <el-table
          class="publish-table"
          highlight-selection-row
          ref="uvMapTable"
          :data="uvMapList"
          height="100%"
          @select="selectChange"
          @select-all="selectChange">
          <el-table-column
            type="selection"
            width="60" />
          <el-table-column
            label="序号"
            type="index"
            width="55" />
          <el-table-column label="名称">
            <template v-slot="{ row }">
              <div class="name-box">
                <div class="icon-box">
                  <icon-svg
                    v-if="row.upgraded"
                    icon-class="ic-jiancegengxin" />
                </div>
                <div
                  class="text-overflow"
                  :title="row.fileName">
                  {{ row.fileName }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="大小">
            <template v-slot="{ row }">
              <div class="text-overflow">
                {{
                  `${formatFileSize(row.fileSize).fileSize}${
                    formatFileSize(row.fileSize).unit
                  }`
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="更新日期">
            <template v-slot="{ row }">
              <div>
                {{
                  row.lastModificationTime
                    ? formatTime(row.lastModificationTime)
                    : formatTime(row.creationTime)
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180">
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  type="text"
                  size="small"
                  class="upload-text-btn upload-btn-error"
                  :id="`refresh-${row.rvtUvMappingId}`"
                  @click="reUpload(row)">
                  更新
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="downloadFile(row)">
                  下载
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="deleteFileById(row)">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="common-empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <template slot="description">
                  <div class="empty-text">抱歉，没有找到相关内容</div>
                </template>
              </bj-empty>
            </div>
          </template>
        </el-table>
      </div>
      <div
        class="common-card-box"
        v-if="currViewMode === 'card'">
        <div
          v-if="uvMapList.length"
          class="uvcontent-box">
          <div class="common-checkbox-box">
            <el-checkbox
              class="checkbox-primary"
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
          </div>
          <div class="uvmap-list-box">
            <div
              v-for="item in uvMapList"
              :key="item.rvtUvMappingId"
              class="item-box">
              <div
                :class="`common-checkbox-box ${
                  isItemChecked(item) ? 'active' : ''
                }`">
                <el-checkbox
                  class="checkbox-primary"
                  :value="isItemChecked(item)"
                  @change="checked => handleCheckChange(item, checked)" />
              </div>
              <div class="operation-button-box">
                <div
                  title="下载"
                  @click="downloadFile(item)">
                  <icon-svg
                    icon-class="icon-xiazai"
                    class="icon" />
                </div>
                <div
                  title="删除"
                  @click="deleteFileById(item)">
                  <icon-svg
                    icon-class="icon-shanchu"
                    class="icon" />
                </div>
              </div>
              <div class="img-box">
                <!-- <div class="mask"></div> -->
                <el-button
                  ref="reLoadBtn"
                  type="text"
                  size="small"
                  class="upload-text-btn normal-btn"
                  :id="`refresh-${item.rvtUvMappingId}`"
                  @click="reUpload(item)">
                  <img
                    class="img-box-viewImg"
                    :src="getThumbnail(item)" />
                </el-button>
              </div>
              <div class="name-box">
                <div class="icon-box">
                  <icon-svg
                    v-if="item.upgraded"
                    icon-class="ic-jiancegengxin" />
                </div>
                <div
                  class="text-overflow"
                  :title="item.fileName">
                  {{ item.fileName }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="common-empty-box">
          <bj-empty
            :image="require('@/assets/img/no-data.png')"
            class="empty-page">
            <template slot="description">
              <div class="empty-text">抱歉，没有找到相关内容</div>
            </template>
          </bj-empty>
        </div>
      </div>
    </div>
    <div class="common-pagination-box pagination-primary">
      <el-pagination
        popper-class="common-pagination-popper-box"
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 150, 200]"
        :page-size="size"
        :current-page="page"
        :total="total"
        @size-change="sizeChange"
        @current-change="pageChange">
      </el-pagination>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import RvtUvUploader from '@/utils/rvtUvUploader'
import { Store } from '@/utils/store'

import { formatFileSize, formatTime, getTokenId } from '@/utils/generalMethods'

import { queryUvMapListService, deleteRvtUvService } from '@/service/interface'

export default {
  data() {
    return {
      currViewMode: 'table',
      uvMapList: [],
      selectFiles: [],
      isIndeterminate: false,
      checkAll: false,

      keywords: '',
      page: 1,
      size: 10,
      total: 0
    }
  },
  props: {
    visible: Boolean,
    dataInfo: Object,
    refreshDataSetTable: Function,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  created() {
    let uploaders = Store.uploaders
    let find = uploaders.find(el => el.schemeType === 'Rvtuv')
    if (find) {
      this.customUploader = find.uploader
      this.customUploader.setDataSetId('')
    } else {
      this.customUploader = new RvtUvUploader('Rvtuv')
    }
  },
  mounted() {
    this.customUploader.on('rvtUvUploadSuccess', this.updateUvMapList)
  },
  beforeDestroy() {
    this.customUploader.off('rvtUvUploadSuccess', this.updateUvMapList)
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initUvMapList()

        let dataSetId = this.dataInfo.nodeId
        this.customUploader.setDataSetId(dataSetId)

        this.$nextTick(() => {
          this.initUploadBtn()
        })
      }
    }
  },
  methods: {
    initUvMapList() {
      this.queryUvMapList().then(uvMapList => {
        this.uvMapList = uvMapList

        this.$nextTick(() => {
          this.refeshDom()
        })
      })
    },
    switchViewMode() {
      let currViewMode = this.currViewMode
      if (currViewMode === 'table') {
        this.currViewMode = 'card'
      } else {
        this.currViewMode = 'table'
      }

      this.page = 1
      this.size = 10
      this.updateUvMapList()
    },
    search() {
      this.updateUvMapList()
    },
    selectChange(selection) {
      this.selectFiles = selection
    },
    sizeChange(size) {
      this.size = size
      this.page = 1
      this.updateUvMapList()
    },
    pageChange(page) {
      this.page = page
      this.updateUvMapList()
    },
    uploadFile() {
      this.customUploader.setStatus('waiting')
    },
    reUpload(fileInfo) {
      this.customUploader.setStatus('update')
      this.customUploader.setCurrFileInfo(fileInfo)
    },
    downloadFile(fileInfo) {
      let files = [fileInfo]
      this.downloadFiles(files)
    },
    bathchDownload() {
      let selectFiles = this.selectFiles
      if (!selectFiles.length) {
        this.$message.warning('请先勾选文件')
        return
      }

      this.downloadFiles(selectFiles)
    },
    deleteFileById(fileInfo) {
      this.$confirm('删除后需要重新上传，确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            rvtUvIds: [fileInfo.rvtUvMappingId]
          }
          deleteRvtUvService(params).then(response => {
            if (response.isSuccess) {
              this.page = 1
              this.updateUvMapList().then(() => {
                this.$message.success('删除成功!')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    batchDelete() {
      let selectFiles = this.selectFiles
      if (!selectFiles.length) {
        this.$message.warning('请先勾选文件')
        return
      }

      this.$confirm('删除后需要重新上传，确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let rvtUvIds = selectFiles.map(item => item.rvtUvMappingId)
          let params = { rvtUvIds }
          deleteRvtUvService(params).then(response => {
            if (response.isSuccess) {
              this.page = 1
              this.updateUvMapList().then(() => {
                this.$message.success('删除成功!')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    downloadFiles(files) {
      this.$message({
        message: '开始下载文件，请勿重复操作......',
        type: 'info',
        duration: 3 * 1000
      })

      files.forEach((item, index) => {
        let url = ''
        let tokenId = getTokenId()
        if (window.downloadUrl.includes('http')) {
          url = `${window.downloadUrl}/${item.fileDataId}?token=${tokenId}`
        } else {
          url = `${window.serverUrl}/${window.downloadUrl}/${item.fileDataId}?token=${tokenId}`
        }

        this.downloadURL(url, index + 1)
      })
    },
    downloadURL(url, id) {
      let hiddenIFrameID = 'hiddenDownloader' + id
      let iframe = document.createElement('iframe')
      iframe.id = hiddenIFrameID
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      iframe.src = url
    },
    getThumbnail(imgInfo) {
      let timestamp = new Date().getTime()
      let imgBaseUrl = `${window.serverUrl}/${window.downloadUrl}`
      return `${imgBaseUrl}/${
        imgInfo.fileDataId
      }?token=${getTokenId()}&timestamp=${timestamp}`
    },
    cancel() {
      this.uvMapList = []
      this.selectFiles = []

      this.currViewMode = 'table'

      this.keywords = ''
      this.page = 1
      this.size = 10
      this.total = 0

      this.closeDialog()
    },
    handleCheckChange(data, checked) {
      let findIndex = this.selectFiles.findIndex(
        el => el.rvtUvMappingId === data.rvtUvMappingId
      )
      if (checked && findIndex === -1) {
        this.selectFiles.push(data)
      }
      if (!checked && findIndex !== -1) {
        this.selectFiles.splice(findIndex, 1)
      }

      let checkedCount = this.selectFiles.length
      let total = this.uvMapList.length
      this.checkAll = checkedCount === total
      this.isIndeterminate = checkedCount > 0 && checkedCount < total
    },
    handleCheckAllChange(checked) {
      if (checked) {
        let uvMapList = this.uvMapList.map(item => item)
        this.selectFiles = uvMapList
      } else {
        this.selectFiles = []
      }

      let checkedCount = this.selectFiles.length
      let total = this.uvMapList.length
      this.checkAll = checkedCount === total
      this.isIndeterminate = checkedCount > 0 && checkedCount < total
    },
    isItemChecked(data) {
      let find = this.selectFiles.find(
        el => el.rvtUvMappingId === data.rvtUvMappingId
      )
      let checked = find ? true : false
      return checked
    },
    updateUvMapList() {
      return new Promise(resolve => {
        this.queryUvMapList().then(uvMapList => {
          this.uvMapList = uvMapList
          this.refreshDataSetTable()

          this.$nextTick(() => {
            this.refeshDom()
          })

          resolve()
        })
      })
    },
    queryUvMapList() {
      return new Promise(resolve => {
        let dataSetId = this.dataInfo.nodeId
        let params = {
          dataSetId,
          fileName: this.keywords,
          skipCount: (this.page - 1) * this.size,
          resultCount: this.size
        }
        queryUvMapListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            this.total = data.totalCount
            resolve(data.items)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    initUploadBtn() {
      let uploadDom = document.getElementById('rvt-uvmap-upload')
      if (uploadDom) {
        let child = uploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.customUploader.uploader.addButton({ id: '#rvt-uvmap-upload' })
        }
      }
    },
    refeshDom() {
      let uvMapList = this.uvMapList

      uvMapList.forEach(item => {
        let domId = `refresh-${item.rvtUvMappingId}`
        let refreshDom = document.getElementById(domId)
        let child = refreshDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.customUploader.uploader.addButton({
            id: `#refresh-${item.rvtUvMappingId}`,
            multiple: false
          })
        }
      })
    },
    formatFileSize,
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.operation-area-box {
  display: flex;
  justify-content: space-between;
  .filter-box {
    display: flex;
    align-items: center;

    .icon-box {
      margin-left: 6px;
      font-size: 19px;
      color: var(--bim-rvt-uv-icon-color);
      cursor: pointer;
    }

    .operation-icon {
      :deep(.svg-icon) {
        &:hover {
          color: var(--base-primary-bgColor);
        }
      }
    }
  }
}

.uvmap-data-box {
  height: 380px;

  .tip-box {
    margin: 16px 0px;
    font-size: 12px;
    // color: #aaaaaa;
  }

  .common-table-box {
    height: calc(100% - 25px);

    .name-box {
      display: flex;
      .icon-box {
        margin-right: 5px;
      }
    }

    .upload-text-btn {
      height: 20px;
      /deep/ .webuploader-pick {
        margin-left: 5px;
        margin-bottom: -7px;
      }
    }
  }

  .operation-cell {
    .upload-btn-error {
      height: 26px !important;
      line-height: 26px;

      :deep(.webuploader-pick) {
        margin-bottom: 0;
      }
    }
  }

  .common-card-box {
    height: calc(100% - 46px);

    .common-checkbox-box {
      margin-bottom: 8px;
    }
    .uvcontent-box {
      height: 100%;
      .uvmap-list-box {
        display: flex;
        flex-wrap: wrap;
        height: calc(100% - 40px);
        margin-top: 5px;
        overflow: auto;

        .item-box {
          display: flex;
          flex-direction: column;
          position: relative;
          width: calc((100% - 40px) / 6);
          height: 185px;
          box-shadow: var(--base-bg-dark-color31);
          border-radius: 8px;
          border: 1px solid var(--bim-rvt-uv-border-color);
          cursor: pointer;
          padding: 8px;
          margin-right: 8px;
          &:nth-child(6n) {
            margin-right: 0px;
          }

          .img-box {
            flex: 1;
            height: 144px;
            display: flex;
            background: var(--bim-rvt-uv-bg-color);
            border-radius: 4px;
            overflow: hidden;
            position: relative;

            &-viewImg {
              object-fit: fill;
              width: 136px;
              height: 143px;
              transition: all 0.3s;
            }
            :deep(.el-button) {
              width: 100%;
              height: 100%;
              background-color: transparent;
              padding: 0;
              .webuploader-pick {
                padding: 0;
                width: 100%;
                height: 100%;

                span {
                  display: block;
                  height: 100%;
                  width: 100%;

                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }

              .webuploader-pick-hover {
                span {
                  position: relative;
                  &::before {
                    position: absolute;
                    content: '';
                    display: block;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    background-color: var(--dialog-mask-bgColor);
                  }
                }
              }
            }
          }

          .name-box {
            display: flex;
            margin-top: 4px;
            color: var(--bim-rvt-uv-text-color);
            font-size: 14px;
            font-weight: 400;
            // border-top: 1px solid #4e4d56;
            .icon-box {
              margin: 0px 6px;
            }
          }

          .common-checkbox-box {
            position: absolute;
            top: 7px;
            left: 14px;
            display: none;
            z-index: 2;
            &.active {
              display: block;
            }
          }

          .operation-button-box {
            position: absolute;
            top: 13px;
            right: 13px;
            display: none;
            z-index: 2;
            .icon {
              margin-left: 6px;
              color: var(--base-primary-bgColor);
              font-size: 16px;
              line-height: 26px;
            }
          }

          &:hover {
            .common-checkbox-box {
              display: block;
            }

            .operation-button-box {
              display: flex;
            }

            .mask {
              display: block;
            }
          }

          &.active {
            .common-checkbox-box {
              display: block;
            }

            .operation-button-box {
              display: flex;
            }
          }
        }
      }
    }

    .common-empty-box {
      color: #909399;
    }
  }
}

.common-pagination-box {
  // margin-top: 10px;
  margin-bottom: -16px;
  text-align: center;
}
</style>
